module.exports = __webpack_public_path__ + "img/1586094437.dec58d01.jpg";